import React from 'react';
import { Plus, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import RequestKindIcon from '../ui/RequestKindIcon';
import { REQUEST_KIND_OPTIONS } from '../../utils/requestKinds';

/**
 * The sidebar context menu's "Add ›" entry: ONE row that opens a submenu — Request,
 * GraphQL, WebSocket, Server-Sent Events, gRPC — instead of five "Add …" rows in the
 * menu itself. Built like the menu's "Share ›" (same `.ctx-submenu*` classes, opens on
 * hover / focus / click); the parent owns which submenu is open, so only one ever is.
 * Same list and icons (lucide) as the tab strip's picker: both read REQUEST_KIND_OPTIONS.
 *
 * @param {{ open: boolean, onOpenChange: (open: boolean) => void, flipLeft: boolean, onAdd: (optionId: string) => void }} props
 */
export default function AddRequestSubmenu({ open, onOpenChange, flipLeft = false, onAdd }) {
  const { t } = useTranslation();
  return (
    <div className="ctx-submenu" onMouseEnter={() => onOpenChange(true)} onMouseLeave={() => onOpenChange(false)}>
      <button
        type="button"
        className="ctx-menu-btn"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => onOpenChange(!open)}
        onFocus={() => onOpenChange(true)}
      >
        <Plus size={14} />
        <span>{t('sidebar.add')}</span>
        <ChevronRight size={13} className="ctx-submenu-caret" />
      </button>
      {open && (
        <div
          role="menu"
          style={{ minWidth: 200, whiteSpace: 'nowrap' }}
          className={`ctx-submenu-panel rounded-lg border border-gray-200 bg-white py-2 shadow-lg dark:border-zinc-700 dark:bg-zinc-900 ${flipLeft ? 'ctx-submenu-panel--left' : ''}`}
        >
          {REQUEST_KIND_OPTIONS.map((option) => (
            <button key={option.id} type="button" role="menuitem" className="ctx-menu-btn" onClick={() => onAdd(option.id)}>
              <RequestKindIcon optionId={option.id} size={14} />
              <span>{t(option.id === 'http' ? 'sidebar.addSubRequest' : option.labelKey)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
